module.exports = __webpack_public_path__ + "img/logo.066d3a4f.svg";